module.exports = __webpack_public_path__ + "img/1.fb53502a.jpg";